import { Link } from 'react-router-dom';

const stats = [
  { value: '20+', label: '收录剧集', icon: 'ri-film-line' },
  { value: '高清', label: '画质播放', icon: 'ri-hd-line' },
  { value: '每日', label: '更新追综', icon: 'ri-calendar-check-line' },
  { value: '免费', label: '无需注册', icon: 'ri-shield-check-line' },
];

export default function IntroSection() {
  return (
    <section className="w-full bg-primary-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr] lg:items-center lg:gap-16">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-400">About The Platform</p>
            <h1 className="mt-3 font-heading text-2xl font-semibold text-background-50 md:text-4xl">
              妈妈的朋友在线观看
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              我们是一个专注热门电视剧的资料查询与在线观看入口平台。围绕《妈妈的朋友》及当下热播剧集，提供详尽的剧情简介、演员阵容与剧集更新信息，帮助你快速筛选、定位并开始观看喜欢的剧集。
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to="/category"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-compass-3-line text-lg" />
                开始找剧
              </Link>
              <Link
                to="/about"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                了解我们
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((item) => (
              <div key={item.label} className="rounded-lg border border-background-50/10 bg-background-50/5 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <p className="mt-3 font-heading text-2xl font-semibold text-background-50">{item.value}</p>
                <p className="mt-1 text-sm text-background-400">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}